// extracted by mini-css-extract-plugin
export var assigneeBadge = "_nr-0";
export var assigneeDetails = "_nr-1";
export var assigneeInfo = "_nr-2";
export var dropdownContainer = "_nr-4";
export var dropdownImage = "_nr-5";
export var editAssigneeInfo = "_nr-3";
export var editAssigneeModalContainer = "_nr-6";
export var hidden = "_nr-8";
export var input = "_nr-7";